import CircularRectTextButton, {
    CircularRectTextButtonProps,
} from "@/components/CircularButton/styled/CircularRectTextButton";
import { iconSizes } from "@/utils/iconProps";
import { themeColors } from "@/utils/themeColors";
import { SearchIcon } from "lucide-react";
import dynamic from "next/dynamic";
import { useState } from "react";
import LazyLoaded from "@/components/LazyLoaded";
import clsx from "clsx";

const SearchPopup = dynamic(() => import("@/components/popupWithSidebar/SearchPopup"));

const SearchBar = ({ sx }: { sx?: CircularRectTextButtonProps["sx"] }) => {
    const [isSearchPopupOpen, setIsSearchPopupOpen] = useState(false);

    return (
        <>
            <CircularRectTextButton
                className={clsx("ellipsisText", "secondaryText2")}
                sx={{
                    height: "4rem",
                    backgroundColor: themeColors.background,
                    color: themeColors.neutral2,
                    fontWeight: "normal",
                    fontSize: "1.4rem",
                    gap: "1rem",
                    padding: "0rem 2rem",
                    justifyContent: "flex-start",
                    ...sx,
                }}
                onClick={() => setIsSearchPopupOpen(true)}>
                <SearchIcon size={iconSizes.SM} />
                Search for anything
            </CircularRectTextButton>

            <LazyLoaded load={isSearchPopupOpen}>
                <SearchPopup isOpen={isSearchPopupOpen} onClose={() => setIsSearchPopupOpen(false)} />
            </LazyLoaded>
        </>
    );
};

export default SearchBar;
